<p>
  email-list-index works!
</p>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/email/email-list-index/email-list-index.component.html